import { PIN_LENGTH } from "./constants"

const KEYPAD_DIGITS = ["1", "2", "3", "4", "5", "6", "7", "8", "9"]

interface PinKeypadProps {
  pin: string
  errorMessage: string
  isValidating: boolean
  onDigit: (digit: string) => void
  onDelete: () => void
}

const PinKeypad = ({ pin, errorMessage, isValidating, onDigit, onDelete }: PinKeypadProps) => {
  const dotClassName = (index: number) => {
    if (errorMessage) return "pin-dot error"
    return index < pin.length ? "pin-dot filled" : "pin-dot"
  }

  return (
    <div className="screen">
      <div className="pin-screen">
        <div style={{ textAlign: "center" }}>
          <div className="pin-title">Enter your PIN</div>
          <div className="pin-sub">
            {isValidating ? "Checking…" : "Check your email for today's PIN"}
          </div>
        </div>

        <div className="pin-dots">
          {Array.from({ length: PIN_LENGTH }, (_, index) => (
            <div className={dotClassName(index)} key={index} />
          ))}
        </div>

        <div className="pin-error">{errorMessage}</div>

        <div className="keypad">
          {KEYPAD_DIGITS.map((digit) => (
            <button
              className="key"
              disabled={isValidating}
              key={digit}
              onClick={() => onDigit(digit)}
              type="button"
            >
              {digit}
            </button>
          ))}
          <button className="key empty" tabIndex={-1} type="button" />
          <button
            className="key"
            disabled={isValidating}
            onClick={() => onDigit("0")}
            type="button"
          >
            0
          </button>
          <button className="key del" disabled={isValidating} onClick={onDelete} type="button">
            ⌫
          </button>
        </div>
      </div>
    </div>
  )
}

export default PinKeypad
